import React from "react";
import PropTypes from "prop-types";
import cc from "classcat";
import { twMerge } from "tailwind-merge";
import useDarkMode from "../../hooks/useDarkMode";
Spinner.propTypes = {
    variant: PropTypes.oneOf([
        "primary",
        "secondary",
        "contrast"
    ]),
    size: PropTypes.oneOf([
        "small",
        "medium",
        "large"
    ]),
    className: PropTypes.string
};
export default function Spinner(param) {
    var tmp = param.variant, _variant = tmp === void 0 ? "primary" : tmp, _param_size = param.size, size = _param_size === void 0 ? "medium" : _param_size, className = param.className;
    // TODO sizes + colors (used in button also based on the button color!!) + inside a container/card
    //  https://preline.co/docs/spinners.html#customized-description
    var darkMode = useDarkMode();
    var variant = _variant;
    if (_variant === "contrast") {
        //Use this when outside of buttons to ensure the spinner is visible
        variant = darkMode ? "secondary" : "primary";
    }
    return /*#__PURE__*/ React.createElement("span", {
        className: twMerge(cc([
            "inline-block animate-spin rounded-full border-[3px] border-current border-t-transparent",
            {
                "h-4 w-4": size === "small"
            },
            {
                "h-6 w-6 ": size === "medium"
            },
            {
                "h-8 w-8 ": size === "large"
            },
            {
                "text-gray-50": variant === "secondary"
            },
            {
                "text-blue-600 dark:text-gray-50": variant === "primary"
            },
            className
        ])),
        role: "status",
        "aria-label": "loading"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Loading..."));
}
